export const rightString = (text: string, lenght: number): string => {
  if (text.length <= lenght) {
    return text;
  }
  return text.substring(text.length, text.length - lenght);
};
